import PublicNav from "@/components/PublicNav";
import Footer from "@/components/Footer";

const sections = [
  ["Introduction", "Nirmantra.ai (\"we\", \"us\") provides an AI-powered construction advisory platform for independent homeowners in India. This Privacy Policy explains how we collect, use and protect your information."],
  ["Information We Collect", "We collect your name, email and profile picture via Google Sign-In, project details you enter (plot size, budget, city), documents you upload (floor plans, BOQs, quotations, soil reports, images) and consultation requests you submit."],
  ["How We Use Your Information", "We use your information to generate your Construction Health Report, provide AI advisory chat, connect you with expert advisors, and improve our services. Your documents are analysed solely to produce insights for your own project."],
  ["Document Security", "Your uploaded documents are stored securely and are accessible only to you through your authenticated account. We do not sell or share your project data with third parties."],
  ["AI Processing", "To generate reports and chat responses, relevant project details and document text are processed by our AI provider under strict confidentiality. We do not use your private documents to train public models."],
  ["Data Retention", "We retain your project data for as long as your account is active. You may request deletion of your data at any time by contacting us."],
  ["Your Rights", "You have the right to access, correct or delete your personal data. Contact us to exercise these rights."],
  ["Contact", "For any privacy questions, reach us via the Contact page."],
];

export default function Privacy() {
  return (
    <div className="min-h-screen bg-white">
      <PublicNav />
      <main className="max-w-3xl mx-auto px-6 py-16 lg:py-20">
        <h1 className="font-display text-4xl lg:text-5xl tracking-tighter font-extrabold text-slate-900">Privacy Policy</h1>
        <p className="mt-3 text-slate-500">Last updated: June 2026</p>
        <div className="mt-10 space-y-8">
          {sections.map(([t, d], i) => (
            <div key={i}>
              <h2 className="font-display text-xl font-bold text-slate-900">{t}</h2>
              <p className="mt-2 text-slate-600 leading-relaxed">{d}</p>
            </div>
          ))}
        </div>
      </main>
      <Footer />
    </div>
  );
}
